<div class="doc-type-filter-bar" [class.doc-type-filter-bar--compact]="size === 'compact'">
  @if (!wrapAll) {
    <!-- Offscreen measure row for overflow calc -->
    <div #measure class="doc-type-filter-bar__measure" aria-hidden="true">
      @if (showAllChip) {
        <app-document-type-chip [label]="allLabel | translate" [active]="false" [size]="size" />
      }
      @for (subtype of subtypes; track subtype.id) {
        <app-document-type-chip
          [label]="subtype.displayedName"
          [active]="false"
          [count]="counts[subtype.id]"
          [selectedCount]="selectedCounts[subtype.id]"
          [color]="colorFor(subtype)"
          [size]="size"
        />
      }
      <button type="button" class="doc-type-filter-bar__more">
        {{ 'tenders.library.filter-more' | translate: { count: subtypes.length } }}
      </button>
    </div>
  }

  <div #row class="doc-type-filter-bar__row" [class.doc-type-filter-bar__row--wrap]="wrapAll || expanded">
    @if (showAllChip) {
      <app-document-type-chip [label]="allLabel | translate" [active]="isAllActive" [size]="size" (toggle)="onAll()" />
    }
    @for (subtype of visibleSubtypes; track subtype.id) {
      <app-document-type-chip
        [label]="subtype.displayedName"
        [active]="isActive(subtype.id)"
        [count]="counts[subtype.id]"
        [selectedCount]="selectedCounts[subtype.id]"
        [color]="colorFor(subtype)"
        [size]="size"
        (toggle)="toggle.emit(subtype.id)"
      />
    }
    @if (!wrapAll && !expanded && hiddenCount > 0) {
      <button type="button" class="doc-type-filter-bar__more" (click)="expand()">
        {{ 'tenders.library.filter-more' | translate: { count: hiddenCount } }}
      </button>
    }
    @if (!wrapAll && expanded && hiddenCount > 0) {
      <button type="button" class="doc-type-filter-bar__more" (click)="collapse()">
        {{ 'tenders.library.filter-reduce' | translate }}
      </button>
    }
  </div>
</div>
